import { apiGet, apiPatch, apiPost } from './client';
import type {
  SpecialRate,
  SpecialRateBatchRequest,
  SpecialRateEffective,
  SpecialRateRangeRequest,
} from '../types/SpecialRate';

// Tenant-scoped special rates (X-Tenant-Id applied automatically by client).
export function getSpecialRates(): Promise<SpecialRate[]> {
  return apiGet<SpecialRate[]>('/api/special-rates');
}

export function saveSpecialRatesBatch(
  added: SpecialRate[],
  modified: SpecialRate[],
  deletedIds: number[],
): Promise<SpecialRate[]> {
  return apiPatch<SpecialRateBatchRequest, SpecialRate[]>(
    '/api/special-rates/batch',
    { added, modified, deleted: deletedIds },
  );
}

export function addSpecialRatesRange(
  req: SpecialRateRangeRequest,
): Promise<SpecialRate[]> {
  return apiPost<SpecialRateRangeRequest, SpecialRate[]>(
    '/api/special-rates/range',
    req,
  );
}

export function getSpecialRatesEffective(): Promise<SpecialRateEffective[]> {
  return apiGet<SpecialRateEffective[]>('/api/special-rates/effective');
}
